import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Switch from '@material-ui/core/Switch';

class Filter extends React.Component {

    state = {
        open: this.props.options.indexOf(1) >= 0,
        out: this.props.options.indexOf(2) >= 0,
        closed: this.props.options.indexOf(3) >= 0,
        closedout: this.props.options.indexOf(4) >= 0,
        novalue: this.props.options.indexOf(5) >= 0,
        correct: this.props.options.indexOf(6) >= 0,
    }

    handleClose = (options, open, out, closed, closedout, novalue, correct) => (event) => {
        if (open) {
            options.push(1);
        }
        if (out) {
            options.push(2);
        }
        if (closed) {
            options.push(3);
        }
        if (closedout) {
            options.push(4);
        }
        if (novalue) {
            options.push(5);
        }
        if (correct) {
            options.push(6);
        }
        this.props.onClose(options);
    }

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };


    render() {
        const { open, closed, out, closedout, novalue, correct } = this.state;

        return (
            <Dialog
                open={true}
                onClose={this.handleClose([], true, true, true, true, true, true)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="barlow_medium_tree_local flex_full_row margin_top_12 margin_bottom_24 c_dark_grey_blue">
                        <FormattedMessage id="display_filtermenu_status_title" />
                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'open'}
                            checked={open}
                            onChange={this.handleChecked}
                            value="open"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_open" />
                        </div>

                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'out'}
                            checked={out}
                            onChange={this.handleChecked}
                            value="out"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_out_time" />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'closed'}
                            checked={closed}
                            onChange={this.handleChecked}
                            value="closed"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_closed_on_time" />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'closedout'}
                            checked={closedout}
                            onChange={this.handleChecked}
                            value="closedout"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_closed_out_time" />
                        </div>
                    </div>
                    <hr />
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'novalue'}
                            checked={novalue}
                            onChange={this.handleChecked}
                            value="novalue"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_no_task" />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_12 align_center">
                        <Switch
                            name={'correct'}
                            checked={correct}
                            onChange={this.handleChecked}
                            value="correct"
                            color="primary"
                        />
                        <div className="flex_full_row barlow_regular_smalltext c_cool_grey_two">
                            <FormattedMessage id="visibility_correct_task" />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose([], true, true, true, true, true, true)} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button onClick={this.handleClose([], open, out, closed, closedout, novalue, correct)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/reports/visibility/FilterMenu.js